import React from "react";
import "./Blog.css";
import Logo from "../../Components/Logo/Logo";
import Socials from "../../Components/Socials/Socials";
import Navbar from "../../Components/Navbar/Navbar";
import NavFooter from "../../Components/Footer-Nav/NavFooter";
import { motion } from "framer-motion";

const Blog = () => {
  return (
    <motion.div
      className="blogContainer"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <header className="header">
          <Logo />
          <Socials />
          <Navbar />
        </header>
        <div className="posts">Posts were not found</div>
        <NavFooter />
      </div>
    </motion.div>
  );
};

export default Blog;
